export default "__VITE_ASSET__17668152__"